/* eslint-disable no-unused-vars */
import { AppState, useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useSignUpUserAndOrg } from 'views/public/SignUp/hooks';
import { GlobalKeys } from 'helpers/localStorage';

export enum SignUpType {
    SOCIAL = 'SOCIAL',
}

export interface CustomAppState extends AppState {
    organizationName?: string;
    signupType?: SignUpType;
}

export const handleAuthRedirect = (appState?: CustomAppState) => {
    if (appState?.signupType === SignUpType.SOCIAL) {
        localStorage.setItem(GlobalKeys.AppStateBeforeRedirection, JSON.stringify(appState));
    }
    const targetUrl = appState?.returnTo || window.location.pathname;
    window.history.replaceState({}, '', targetUrl);
};

export const HandleNewSocialUser = () => {
    // This component is handles the case when a new user signs up using social login
    const { user } = useAuth0();
    const { mutate: signUpUserAndOrg } = useSignUpUserAndOrg();

    // TODO: handle case where no org name is provided (e.g. from auth0 "dont have account" option)
    // TODO: can we configure that button on auth0 to redirect to our signup page?

    useEffect(() => {
        // This effect creates the northspyre user and org db records from the auth0 user
        if (user && user?.email) {
            const appStateStr = localStorage.getItem(GlobalKeys.AppStateBeforeRedirection);
            const storedAppState: CustomAppState | undefined = appStateStr ? JSON.parse(appStateStr) : undefined;

            if (storedAppState?.signupType === SignUpType.SOCIAL && storedAppState?.organizationName) {
                signUpUserAndOrg({
                    organizationName: storedAppState.organizationName!,
                    name: user.name || '',
                    email: user.email,
                    workEmail: user.email,
                    termsAccepted: false,
                    auth0UserProfile: JSON.stringify(user),
                }, {
                    onSuccess: () => {
                        localStorage.removeItem(GlobalKeys.AppStateBeforeRedirection);
                        const returnTo = storedAppState.returnTo || '/';
                        window.location.replace(returnTo);
                    },
                });
            }
        }
    }, [user]);

    return null;
};
